<script setup lang="ts">
import { FoodMenuItem } from '@caks/uikit/food/'
import { useAccountStore } from '@caks/shared/store/store.account'
import { SkeletonFoodMenuItem } from '@caks/uikit/skeleton'

const store = useAccountStore()

interface Props {
  desktop: boolean
  foods: Array<{
    id: number
    main_media: string
    medias: Array<string>
    name: string
    description: string
    available_modifications: {
      base_modifcators: Array<{
        id: number
        name: string
        available_variants: Array<{
          id: number
          name: string
        }>
      }>
      extra_modificators: Array<{
        id: number
        name: string
        image: string
        cost: number
      }>
      ingridients: Array<{
        id: number
        name: string
        required: boolean
      }>
    }
    base_cost: number
    base_bju: {
      kkal: number
    }
  }>
}
const props = withDefaults(defineProps<Props>(), {
  desktop: false,
})

const onAddToCart = (food: Object) => {
  store.cachedFoodItem = { ...food }
  // todo: добавление в корзину
}
</script>

<template>
  <div class="food-track" :class="{ 'food-track_desktop': desktop }">
    <div
      v-if="foods.length"
      v-for="food in foods"
      :key="food.id"
      :class="{ 'food-track__wrapper': desktop }"
    >
      <food-menu-item
        :class="{ 'food-track__item': desktop }"
        :desktop="desktop"
        :food="food"
        :key="food.id"
        @addToCart="onAddToCart"
        @beforeRouterPush="onAddToCart"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.food-track {
  &_desktop {
    overflow: hidden;
    /* min-height: 620px;
    display: flex;
    flex-wrap: wrap; */
    gap: 32px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-auto-rows: max-content;
  }
  &__wrapper {
    width: 304px;
    min-height: 420px;
    height: auto;
  }
  &__item {
    width: 100%;
  }
}
</style>
